import hash from "@emotion/hash"

export const cssActive = `css-${hash("menu:section:active")}`
export const cssFixed = `css-${hash("menu:section:fixed")}`
export const cssVarMaxHeight = `--${hash("menu:section:max-height")}`
export const cssVarWidth = `--${hash("menu:section:width")}`
